import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import RootErrorBoundary from "./components/RootErrorBoundary";
import "./index.css";

// Auto-recover from stale chunk errors after a deploy.
// If a dynamic import fails (old index.html → missing /assets/*.js),
// reload once. Guard with sessionStorage to avoid reload loops.
const RELOAD_KEY = "__wmt_reloaded_for_chunk__";
const isChunkError = (msg: string) =>
  /ChunkLoadError|Loading chunk|dynamically imported module|Importing a module script failed|Failed to fetch dynamically/i.test(
    msg,
  );
const tryReload = (msg: string) => {
  if (!isChunkError(msg)) return;
  try {
    if (sessionStorage.getItem(RELOAD_KEY)) return;
    sessionStorage.setItem(RELOAD_KEY, "1");
  } catch {
    /* ignore */
  }
  window.location.reload();
};
window.addEventListener("error", (e) => {
  tryReload(String(e?.message || (e?.error as Error)?.message || ""));
});
window.addEventListener("unhandledrejection", (e) => {
  const reason = e?.reason;
  const msg = typeof reason === "string" ? reason : reason?.message || "";
  tryReload(String(msg));
});
// Clear the flag on a clean load so the next deploy is also covered.
window.addEventListener("load", () => {
  setTimeout(() => {
    try {
      sessionStorage.removeItem(RELOAD_KEY);
    } catch {
      /* ignore */
    }
  }, 4000);
});

createRoot(document.getElementById("root")!).render(
  <RootErrorBoundary>
    <App />
  </RootErrorBoundary>,
);
